<app-navigation-layout [hideHeader]="false" [hideMenu]="true" [hideNavigation]="true" [hideMain]="false">

  <span header-container>
    <h2>{{ 'Loading..' | translate }}</h2>
  </span>

  <span main-container>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h3>{{ 'Enable VU Mode' | translate }}</h3>
        </div>
      </div>
    </div>
  </span>

</app-navigation-layout>
